<template>
    <div>
        <tr v-if="component.type === 'text' && component.options.hidden === false">
            <td class="td-width ">
                <p v-if="!component.options.hideLabel && typeof component.display.label !== 'undefined' && component.display.label !== ''" class="is-size-6 th is-flex ai-center">{{component.display.label}}:
                    <b-tooltip  v-if="component.options.toolTip !== ''" :label="component.options.toolTip" size="is-small" class="mg-l-5" type="is-dark">
                        <b-icon pack="fas" size="is-small" icon="question-circle" class="has-text-grey-light"></b-icon>
                    </b-tooltip>
                </p>
            </td>  
            <td class="td-width" v-if="typeof inputValue[component.name] !== 'undefined' && inputValue[component.name] !== null && inputValue[component.name] !== ''">
                {{inputValue[component.name]}}
            </td>
            <span v-else>-</span>

        </tr>
        <tr v-if="component.type === 'textarea'">
            <td class="td-width-text-area">
                <p class="is-size-6 th" v-if="typeof component.display.label !== 'undefined' && component.display.label !== ''">{{component.display.label}}:</p>
            </td>
            <td style="text-align-justify">
                <p class="mg-35" v-if="typeof inputValue[component.name] !== 'undefined' &&inputValue[component.name] !== null && inputValue[component.name] !== ''">{{inputValue[component.name]}}</p>
                <span v-else>-</span>
            </td>
        </tr>
        <tr v-if="component.type === 'select'">
            <td class="td-width">
                <p class="is-size-6 th" v-if="typeof component.display.label !== 'undefined' && component.display.label !== ''">{{component.display.label}}:</p>
            </td>
            <td class="td-width" >
                <p class="" v-if="typeof inputValue[component.name] !== 'undefined' && inputValue[component.name] !== null && inputValue[component.name] !== '' && typeof inputValue[component.name].label !== 'undefined'">{{inputValue[component.name].label}}</p>
                <p class="" v-else-if="typeof inputValue[component.name] !== 'undefined' &&inputValue[component.name] !== null && inputValue[component.name] !== ''">{{inputValue[component.name].formatInternational}}</p>
                <span v-else>-</span>
            </td>
        </tr>
        <tr v-if="component.type === 'file' && component.options.hidden === false">
            <td class="td-width">
                <p v-if="!component.options.hideLabel && typeof component.display.label !== 'undefined' && component.display.label !== ''" class="is-size-6 th is-flex ai-center">{{component.display.label}}:
                <b-tooltip  v-if="component.options.toolTip !== ''" :label="component.options.toolTip" size="is-small" class="mg-l-5" type="is-dark">
                <b-icon pack="fas" size="is-small" icon="question-circle" class="has-text-grey-light"></b-icon>
                </b-tooltip>
                </p>
            </td>
            <td class="td-width">
                <div v-if="typeof inputValue[component.name] !== 'undefined' &&inputValue[component.name] !== null && inputValue[component.name].length !== 0">
                    <div v-for="(item,index) in inputValue[component.name]" :key="index">
                        <p>{{item.name}}</p>
                    </div>
                </div>
                <span v-else>-</span>
            </td>
        </tr>
        <tr v-if="component.type === 'date'">
            <td class="td-width-date">
                <p v-if="typeof component.display.label !== 'undefined' && component.display.label !== ''" class="is-size-6 th is-flex ai-center">{{component.display.label}}:</p>
            </td>
            <td class="td-width-date"  v-if="component.options.type === 'date' || component.options.type === 'datetime' ">
                <p v-if="typeof inputValue[component.name] !== 'undefined' &&inputValue[component.name] !== null && inputValue[component.name] !== ''">{{inputValue[component.name] | dateFomatShortmonth}}</p>
                <span v-else>-</span>
            </td>
        </tr>
            <tr v-if="component.type === 'radio'">
            <td class="td-width" >
                <p  class="is-size-6 th" v-if="typeof component.display.label !== 'undefined' && component.display.label !== ''">{{component.display.label}}:</p>
            </td>
            <td class="td-width" >
                <p v-if="typeof inputValue[component.name] !== 'undefined' && inputValue[component.name] !== null && inputValue[component.name] !== ''">
                    <span v-if="inputValue[component.name].data !== null">
                        <span v-if="inputValue[component.name].data.userValue === true">
                            {{ inputValue[component.name].des }}
                        </span>
                        <span v-else>
                            {{ inputValue[component.name].data.label }}
                        </span>
                    </span>
                </p>
                <span v-else>-</span>
            </td>
        </tr>
        <tr v-if="component.type === 'checkbox'" >
            <td class="td-width">
                <p  class="is-size-6 th" v-if="typeof component.display.label !== 'undefined' && component.display.label !== ''">{{component.display.label}}:</p>
            </td>
            <td class="td-width">
                <div v-if="typeof inputValue[component.name] !== 'undefined' && inputValue[component.name] !== null && inputValue[component.name].length !== 0">
                    <div v-for="(item,index) in inputValue[component.name]" :key="index">
                        <p v-if="item.userValue === false">{{item.label}}</p>
                        <p v-else>{{item.des}}</p>
                    </div>
                </div>
                <span v-else>-</span>
            </td>
        </tr>
        <tr v-if="component.type === 'file'" class="columns m-h-auto ">
            <td class="td-width">
                <p  class="is-size-6 th" v-if="typeof component.display.label !== 'undefined' && component.display.label !== ''">{{component.display.label}}:</p>
            </td>
            <td class="td-width" v-if="inputValue[component.name] != null">
                <div v-if="typeof inputValue[component.name] !== 'undefined' && inputValue[component.name] !== null && typeof inputValue[component.name][0] !== 'undefined'">
                    <div v-for="(item,index) in inputValue[component.name]" :key="index">
                        <p>{{item.name}}</p>
                    </div>
                </div>
                <div v-else-if="typeof inputValue[component.name] !== 'undefined' && inputValue[component.name] !== null">
                    {{inputValue[component.name].name}}
                </div>
                <span v-else>-</span>
            </td>
        </tr>
    </div>
</template>
<script>
export default {
    props:['component','inputValue']
}
</script>
<style scoped>
@page {
  size: A4;
  margin-bottom:  10mm;
  padding-bottom:  10mm;
}

@media print {
    .columns:not(.is-desktop){
        display: block!important;
    }
    .is-flex{
        display: block!important;
    }
    body {margin: 0;}
    p{
        font-size: 14px!important;
    }
    h2{
        font-size: 16px!important;
    }
    .page{
        margin: 0 0 80px 0;
        border: initial;
        border-radius: initial;
        width: initial;
        min-height: initial;
        box-shadow: initial;
        background: initial;
    }
    .pd-15{
        padding: 0!important;
    }
    .column{
        display: inline-block!important;
        padding-top:0px!important;
        padding-bottom:0px!important;
    }
}
    .btn-form-add{
        min-width: 130px;
        min-height: 40px;
        border:1px solid #6D8DF3;
        color: #6D8DF3;
        margin: 5px;
    }.sesstion{
        padding: 10px 0px;
        margin: 5px;
        /* background-color: black;
        color: white; */
    }
.td-width{
    width:250px!important;
}
.td-width-date{
    width:250px!important;
}
.td-width-text-area{
    width:250px!important;
}
.table,tr,td{
    border: none!important;
}
.mg-35{
    margin-right: 35px!important;
    word-break: break-all;
}
</style>

